import clear from "../images/weather-icons/clear-day.png";
import cloudy from "../images/weather-icons/cloudy.png";
import partlyCloudy from "../images/weather-icons/partly-cloudy-day.png";
import rain from "../images/weather-icons/rain.png";
import fog from "../images/weather-icons/fog.png";
import snow from "../images/weather-icons/snow.png";
import wind from "../images/weather-icons/wind.png";

import clearDay from "../images/forecast-icons/clear-day.png";
import clearNight from "../images/forecast-icons/clear-night.png";
import cloud from "../images/forecast-icons/cloudy.png";
import foggy from "../images/forecast-icons/fog.png";
import hail from "../images/forecast-icons/hail.png";
import partlyCloudyDay from "../images/forecast-icons/partly-cloudy-day.png";
import partlyCloudyNight from "../images/forecast-icons/partly-cloudy-night.png";
import rainSnowShowersDay from "../images/forecast-icons/rain-snow-showers-day.png";
import rainSnowShowersNight from "../images/forecast-icons/rain-snow-showers-night.png";
import rainSnow from "../images/forecast-icons/rain-snow.png";
import rainy from "../images/forecast-icons/rain.png";
import showersDay from "../images/forecast-icons/showers-day.png";
import showersNight from "../images/forecast-icons/showers-night.png";
import sleet from "../images/forecast-icons/sleet.png";
import snowShowersDay from "../images/forecast-icons/snow-showers-day.png";
import snowShowersNight from "../images/forecast-icons/snow-showers-night.png";
import snowy from "../images/forecast-icons/snow.png";
import thunderRain from "../images/forecast-icons/thunder-rain.png";
import thunderShowersDay from "../images/forecast-icons/thunder-showers-day.png";
import thunderShowersNight from "../images/forecast-icons/thunder-showers-night.png";
import thunder from "../images/forecast-icons/thunder.png";
import windy from "../images/forecast-icons/wind.png";

export const iconUrl = {
  clear,
  cloudy,
  partlyCloudy,
  rain,
  fog,
  snow,
  wind,
  clearDay,
  sleet,
  thunder,
  windy,
  snowShowersDay,
  thunderShowersDay,
  thunderShowersNight,
  snowy,
  snowShowersNight,
  clearNight,
  cloud,
  foggy,
  hail,
  partlyCloudyDay,
  partlyCloudyNight,
  rainSnowShowersDay,
  rainSnowShowersNight,
  rainy,
  thunderRain,
  rainSnow,
  showersDay,
  showersNight,
};
